import { render, staticRenderFns } from "./AUnread.vue?vue&type=template&id=7683f754&scoped=true"
import script from "./AUnread.vue?vue&type=script&lang=ts"
export * from "./AUnread.vue?vue&type=script&lang=ts"
import style0 from "./AUnread.vue?vue&type=style&index=0&id=7683f754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7683f754",
  null
  
)

export default component.exports